var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0786 14.8553L2.92578 12.1978L5.59113 3.04492L14.744 5.70245L12.0786 14.8553ZM4.30926 11.4396L11.3283 13.4796L13.3683 6.46063L6.3493 4.42058L4.30926 11.4396Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04922 8.14941C9.50256 8.14941 9.85429 8.50115 9.85429 8.95449C9.85429 9.40783 9.50256 9.75956 9.04922 9.75956C8.59587 9.75956 8.24414 9.40783 8.24414 8.95449C8.25196 8.50115 8.60369 8.14941 9.04922 8.14941ZM8.49426 10.3302H9.60417V15.4811H8.49426V10.3302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallWhiteLogo);
export default __webpack_public_path__ + "static/media/small_white_logo.324e9a14d7a4c13e5a781b1eec940afc.svg";
export { ForwardRef as ReactComponent };